import { Injectable, inject } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { ApiService } from './api.service'
import { CookieService } from 'ngx-cookie-service'

export const AFFILIATES_COOKIE = 'affiliate_cookie'
export const AFFILIATES_COOKIE_USED = 'affiliates_used'

interface NavigationPayload {
  id: number
  url: string
  urlAfterRedirects: string
}

@Injectable({ providedIn: 'root' })
export class CustomerNavigationService {
  private router = inject(Router)
  private api = inject(ApiService)
  private cookieService = inject(CookieService)

  private readonly sessionStorage = 'initialCustomerSession'
  private session: string = ''

  constructor() {
    if (!this.session) {
      this.session = sessionStorage.getItem(this.sessionStorage) ?? ''
      if (!this.session) {
        const session = this.generateSession()
        this.setSession(session)
      }
    }
  }

  init() {
    const affiliateSet = this.cookieService.get(AFFILIATES_COOKIE_USED)
    const affiliateData = affiliateSet ? '' : this.cookieService.get(AFFILIATES_COOKIE)
    const cid = this.cookieService.get('cid')
    const sourceCookie = this.cookieService.get('initialTrafficSource')
    const source = {}
    if (sourceCookie) {
      sourceCookie.split('|').forEach(record => {
        const [utmKey, utmValue] = record.split('=')
        source[utmKey] = utmValue
      })
    }
    if (!affiliateSet) {
      this.api.trackCustomerData(cid, this.session, affiliateData, { source }).subscribe()
    }

    // istanbul ignore next
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
      if (event.urlAfterRedirects.startsWith('/customer-details')) {
        if (!affiliateSet) {
          this.api.trackCustomerData(cid, this.session, affiliateData, { source }).subscribe({
            next: () => {},
            error: () => {},
          })
          this.cookieService.set(AFFILIATES_COOKIE_USED, 'true', { expires: 365 })
        }
      }

      const navigation: NavigationPayload = {
        id: event.id,
        url: event.url,
        urlAfterRedirects: event.urlAfterRedirects,
      }
      this.api.trackCustomerNavigation(this.session, navigation).subscribe({
        next: () => {},
        error: () => {},
      })
    })
  }

  generateSession(): string {
    return [...Array(32)].map(() => (Math.random() + new Date().getTime()).toString(36).slice(-1)).join('')
  }

  getSession(): string {
    return this.session
  }

  resetSession() {
    sessionStorage.removeItem(this.sessionStorage)
  }

  setSession(session: string) {
    this.session = session
    sessionStorage.setItem(this.sessionStorage, this.session)
  }
}
